import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadFormComponent } from './lead-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from '../input-text/input-text.module';
import { DropdownSelectModule } from '../dropdown-select/dropdown-select.module';

@NgModule({
  imports: [
    CommonModule,
    InputTextModule,
    DropdownSelectModule,
    ReactiveFormsModule
  ],
  declarations: [ LeadFormComponent ],
  exports: [ LeadFormComponent ],
})
export class LeadFormModule {}
